import React from "react";
import Moment from "react-moment";
import ProfileBox from "../../Components/ProfileBox/ProfileBox";
import { Grid } from "@mui/material";
import InfiniteScroll from "react-infinite-scroller";
import Badge from "../PublicPage/Rating/badge";
import { getBadges } from "../../Helper";

require("./Dashboard.css");

const RecentFeedback = ({
  user,
  badges,
}) => {
  let length = user.feedback.length;

  const getLatestBadges = () => {
    const userBadges = user.feedback_text
    userBadges.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

    const uniqueBadges = [];
    const seenBadges = new Set();

    for (const entry of userBadges) {
      for (const badge of entry.badges) {
        if (!seenBadges.has(badge.badge_title)) {
            uniqueBadges.push(badge.badge_title);
            seenBadges.add(badge.badge_title);
        }
        if (uniqueBadges.length === 4) break;
      }
      if (uniqueBadges.length === 4) break;
    }

    return uniqueBadges
  }

  const latestBadges = getLatestBadges()
  const badges_data = getBadges();

  const getBadgeData = (title) => {
    title = title.toLowerCase().split(" ").join("");
    let icon_path = "";
    let titleDisplay = "";
    for (let i = 0; i < badges_data.length; i++) {
      let badgesTitle = badges_data[i].badge_title
        .toLowerCase()
        .split(" ")
        .join("");
      if (title === badgesTitle) {
        icon_path = badges_data[i].icon_path;
        titleDisplay = badges_data[i].badge_title;
      }
    }
    return { icon_path, titleDisplay };
  };

  const BadgeArray = badges.map((badge) => {
    return latestBadges.includes(badge.title) ? (
      <Grid
        sx={{
          ".badge-container": {
            width: "100%",
            margin: "0px",
          },
        }}
        className="flex justify-center"
        item
        xs={6}
        lg={6}
      >
        <Badge
          title={badge.title}
          iconURL={getBadgeData(badge.title).icon_path}
          number={badge.count}
          activeClass={false}
        />
      </Grid>
    ) : null;
  });
  
  return (
    <ProfileBox
      header= "Recent feedback">
        <Grid
          item
          xs={12}
          lg={12}
          className=""
        >
          <Grid spacing={{ xs: 1, lg: 4 }} container>
            {BadgeArray}
          </Grid>
        </Grid>
    </ProfileBox>
  );
};

export default RecentFeedback;
// the previous design
// const RecentFeedback = ({ user }) => {
//   let length = user.feedback.length;
//   var badgeName = user.feedback[length - 1].badge_title;
//   if (badgeName === "On the Ball") badgeName = "On-the-ball";

//   // console.log(user.feedback[2].badge_title);
//   return (
//     <div className="flex shadow m-3 p-4 rounded">
//       <div >
//         <img
//           className="shadow-md imageSize"
//           src={require(`../../../src/assets/img/feedbackIcons/${badgeName}.png`)}
//           alt="Logo"
//         />
//       </div>
//       <div className="w-1/3 mx-auto flex flex-col justify-center">
//         <h3>{user.feedback[length - 1].badge_title}</h3>
//         <p className="card-content">You have received</p>
//         <p className="card-content">{user.feedback.length} batches in total</p>
//       </div>
//       <div className="w-1/3 mx-auto flex flex-col justify-center">
//         <h3>
//           <Moment format="DD MMMM">02 June</Moment>
//         </h3>
//         <p className="card-content">IELTS Intermediate</p>
//       </div>
//     </div>
//   );
// };

// export default RecentFeedback;
